/**
 * Возвращает текущий канал продаж, хранящийся в URL
 */
export const getChannel = (): string => {
    const search = window.location.search;
    const searchParams = new URLSearchParams(search);
    const channel = searchParams.get('channel');

    return channel as string;
};
